import {
	apiRequest,
	processInput
} from "@/utilities"

export const regionalAccreditorsService = {
	async getRegionalAccreditors() {
		const getRegionalAccreditorsRequest = {
			method: "GET"
		}
		return await apiRequest("/api/regional-accreditors", getRegionalAccreditorsRequest)
	},
	async createRegionalAccreditor(params) {
		const postRegionalAccreditorRequest = {
			method: "POST",
			data: processInput(params)
		}

		return await apiRequest("/api/regional-accreditors", postRegionalAccreditorRequest)
	},
	async getRegionalAccreditor(uuid) {

		const getRegionalAccreditorRequest = {
			method: "GET"
		}

		return await apiRequest(`/api/regional-accreditors/${uuid}`, getRegionalAccreditorRequest);
	},
	async editRegionalAccreditor(params) {
		const { uuid } = params;
		delete params.uuid;
		let data = processInput(params)
		data.append("_method", "PATCH");
		const updateRegionalAccreditorRequest = {
			method: "POST",
			data
		}

		return await apiRequest(`/api/regional-accreditors/${uuid}`, updateRegionalAccreditorRequest);
	},
	async deleteRegionalAccreditor(uuid) {

		const deleteRegionalAccreditorRequest = {
			method: "DELETE"
		}

		return await apiRequest(`/api/regional-accreditors/${uuid}`, deleteRegionalAccreditorRequest);
	}
}